"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutatePositionAssignUpdate = void 0;
const fetch_1 = __importDefault(require("../util/fetch"));
const error_1 = __importDefault(require("../util/error"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const error_handler_1 = require("@app/util/error-handler");
const apollo_1 = require("@app/util/apollo");
const query = (0, graphql_tag_1.default) `mutation PositionAssignUpdateMutation (
  $workspace: ID!,
  $user: ID!,
  $position: ID!,
  $contract: ID!
  $skill: Int
  $productionForecast: Float
) {
  positionAssignUpdate (
    workspace: $workspace
    user: $user
    position: $position
    contract: $contract
    skill: $skill
    productionForecast: $productionForecast
  ) {
  created
  productionForecast
  skill
  positionId
  }
}`;
const mutatePositionAssignUpdate = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(query, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.positionAssignUpdate;
};
exports.mutatePositionAssignUpdate = mutatePositionAssignUpdate;
async function requestPositionAssignUpdate(variables) {
    const response = await (0, fetch_1.default)({
        variables,
        query,
    });
    if (!response)
        return error_1.default.noResponse();
    // @ts-expect-error
    const { errors, data } = response;
    if (errors) {
        return error_1.default.apiError('position-assign-update', errors);
    }
    return data.positionAssignUpdate;
}
exports.default = requestPositionAssignUpdate;
